import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12 mb-20" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_15 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_16 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-10" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "col-md-2 d-flex align-items-end" }
const _hoisted_21 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = { class: "col-md-9" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "col-md-3" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_28 = {
  key: 1,
  class: "ph ph-scan me-1"
}
const _hoisted_29 = {
  key: 0,
  class: "col-12 text-muted small"
}
const _hoisted_30 = {
  key: 0,
  class: "d-flex flex-column align-items-start"
}
const _hoisted_31 = ["onSubmit"]
const _hoisted_32 = { class: "input-group" }
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = ["disabled", "onClick"]
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = ["onSubmit"]
const _hoisted_37 = {
  class: "input-group",
  style: {"min-width":"150px"}
}
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_40 = { key: 3 }
const _hoisted_41 = { class: "d-flex align-items-center" }
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { key: 4 }
const _hoisted_45 = ["disabled", "onClick"]
const _hoisted_46 = { key: 5 }
const _hoisted_47 = { class: "row mt-40" }
const _hoisted_48 = { class: "col-md-6 mb-2" }
const _hoisted_49 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_50 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 3 }
const _hoisted_54 = { class: "col-md-6 mb-2" }
const _hoisted_55 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_56 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_center = _resolveComponent("center")!
  const _component_TablePager = _resolveComponent("TablePager")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Image du produit ", -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: 
                _ctx.product.pic
                  ? _ctx.product.pic
                  : require('@/assets/images/NoImage.png')
              ,
                class: "rounded-circle me-15",
                style: {"width":"90px","height":"90px","object-fit":"cover"}
              }, null, 8, _hoisted_6),
              _createElementVNode("div", null, [
                _createElementVNode("input", {
                  ref: "updateImgInput",
                  type: "file",
                  accept: "image/*",
                  class: "d-none",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoSelected && _ctx.logoSelected(...args)))
                }, null, 544),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary me-2",
                  onClick: _cache[1] || (_cache[1] = () => _ctx.updateImgInput?.click())
                }, " Choisir la photo "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelImage && _ctx.cancelImage(...args)))
                }, " Annuler ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Nom du produit", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control shadow-none rounded-0 text-black",
                placeholder: "e.g. Sensung Smart Watch",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.product.name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.product.name]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Description Produit ", -1)),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.product.desc) = $event)),
                  placeholder: "Write your product description",
                  class: "form-control shadow-none rounded-0 text-black"
                }, null, 512), [
                  [_vModelText, _ctx.product.desc]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editProduct())),
              class: "btn btn-primary btn-sm",
              disabled: _ctx.loadingEdit
            }, [
              (_ctx.loadingEdit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                : _createCommentVNode("", true),
              _cache[17] || (_cache[17] = _createTextVNode(" Enregistrer ", -1))
            ], 8, _hoisted_13)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { style: {"font-size":"0.957rem"} }, "Choisir une agence * :", -1)),
              _createVNode(_component_v_select, {
                options: _ctx.agencyList,
                modelValue: _ctx.agency,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.agency) = $event)),
                label: "name",
                class: "custom-select-height"
              }, null, 8, ["options", "modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            (_ctx.auth.can('STOCK'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.receivedAgency && _ctx.receivedAgency(...args))),
                  style: {"margin-top":"1.2rem"}
                }, _cache[19] || (_cache[19] = [
                  _createElementVNode("i", { class: "flaticon-check-mark-1" }, null, -1),
                  _createTextVNode(" Reçu ", -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h5", null, "Réception par code-barres"),
        _createElementVNode("p", { class: "mb-0" }, "Scannez la référence du produit pour confirmer sa réception.")
      ], -1)),
      _createElementVNode("div", _hoisted_22, [
        (_ctx.auth.can('STOCK'))
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              class: "row g-2 align-items-end",
              onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.scanInventoryBarcode && _ctx.scanInventoryBarcode(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_23, [
                _cache[20] || (_cache[20] = _createElementVNode("label", {
                  for: "inventoryBarcode",
                  class: "form-label"
                }, "Code-barres / Référence produit", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "inventoryBarcode",
                  ref: "barcodeInput",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.scannedBarcode) = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: "Scannez ou saisissez la référence",
                  autocomplete: "off",
                  disabled: _ctx.barcodeLoading || _ctx.product.received != 1
                }, null, 8, _hoisted_24), [
                  [_vModelText, _ctx.scannedBarcode]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-success w-100",
                  disabled: _ctx.barcodeLoading || !_ctx.scannedBarcode.trim() || _ctx.product.received != 1
                }, [
                  (_ctx.barcodeLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27))
                    : (_openBlock(), _createElementBlock("i", _hoisted_28)),
                  _cache[21] || (_cache[21] = _createTextVNode("Réceptionner le produit ", -1))
                ], 8, _hoisted_26)
              ]),
              (_ctx.product.received != 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, "Sélectionnez d’abord une agence et confirmez la réception du produit."))
                : _createCommentVNode("", true)
            ], 32))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_vue_good_table, {
      columns: _ctx.columns,
      rows: _ctx.product.variantsList
    }, {
      "table-row": _withCtx((props) => [
        (props.column.field === 'inventory_ref')
          ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
              _createElementVNode("form", {
                onSubmit: _withModifiers(($event: any) => (_ctx.updateInventoryRef(props.row)), ["prevent"]),
                class: "w-100"
              }, [
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": ($event: any) => ((props.row.inventory_ref) = $event)
                  }, null, 8, _hoisted_33), [
                    [_vModelText, props.row.inventory_ref]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary btn-sm",
                    title: "Copier la reference",
                    disabled: !props.row.inventory_ref,
                    onClick: ($event: any) => (_ctx.copyInventoryRef(props.row))
                  }, _cache[23] || (_cache[23] = [
                    _createElementVNode("i", { class: "ph ph-copy" }, null, -1)
                  ]), 8, _hoisted_34),
                  _cache[24] || (_cache[24] = _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary btn-sm",
                    title: "Enregistrer la reference"
                  }, [
                    _createElementVNode("i", { class: "flaticon-diskette" })
                  ], -1))
                ])
              ], 40, _hoisted_31),
              (props.row.barcode_svg)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "mt-2",
                    src: 'data:image/svg+xml;base64,' + props.row.barcode_svg,
                    alt: 'Code-barres ' + props.row.inventory_ref,
                    style: {"max-width":"220px","height":"48px"}
                  }, null, 8, _hoisted_35))
                : _createCommentVNode("", true)
            ]))
          : (props.column.field === 'location')
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _withModifiers(($event: any) => (_ctx.updateInventoryLocation(props.row)), ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_37, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    maxlength: "100",
                    placeholder: "Ex : A-02",
                    "onUpdate:modelValue": ($event: any) => ((props.row.location) = $event)
                  }, null, 8, _hoisted_38), [
                    [_vModelText, props.row.location]
                  ]),
                  _cache[25] || (_cache[25] = _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary btn-sm",
                    title: "Enregistrer l'emplacement"
                  }, [
                    _createElementVNode("i", { class: "flaticon-diskette" })
                  ], -1))
                ])
              ], 40, _hoisted_36))
            : (props.column.field === 'stores')
              ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                  (
            props.row.inventories_stores &&
            props.row.inventories_stores.length != 0
          )
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.row.inventories_stores, (str, indx) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "text-nowrap",
                          key: indx
                        }, [
                          _createTextVNode(_toDisplayString(str.magasin.name) + " ", 1),
                          _createElementVNode("small", null, " (" + _toDisplayString(str.magasin.market) + ")", 1)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true)
                ]))
              : (props.column.field === 'qty_not_received')
                ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        min: "-500000",
                        max: "500000",
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => ((props.row.qty_not_received) = $event)
                      }, null, 8, _hoisted_42), [
                        [_vModelText, props.row.qty_not_received]
                      ]),
                      (_ctx.auth.can('STOCK'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            style: {"margin-left":"1%"},
                            class: "btn btn-info",
                            onClick: ($event: any) => (_ctx.editQnty(props.row))
                          }, _cache[26] || (_cache[26] = [
                            _createElementVNode("i", { class: "ph ph-floppy-disk" }, null, -1)
                          ]), 8, _hoisted_43))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : (props.column.field === 'action')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-primary btn-sm text-nowrap",
                        disabled: !props.row.inventory_ref,
                        onClick: _withModifiers(($event: any) => (_ctx.openBarcodePdf(props.row)), ["stop"])
                      }, _cache[27] || (_cache[27] = [
                        _createElementVNode("i", { class: "ph ph-file-pdf me-1" }, null, -1),
                        _createTextVNode("PDF du code-barres ", -1)
                      ]), 8, _hoisted_45)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(props.formattedRow[props.column.field]), 1))
      ]),
      _: 1
    }, 8, ["columns", "rows"]),
    _createElementVNode("div", _hoisted_47, [
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", null, "Historique")
          ], -1)),
          _createElementVNode("div", _hoisted_50, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchHist) = $event)),
              placeholder: "Chercher",
              type: "text",
              class: "form-control d-inline-block mb-2"
            }, null, 512), [
              [_vModelText, _ctx.searchHist]
            ]),
            _createVNode(_component_vue_good_table, {
              columns: _ctx.columnsHist,
              rows: _ctx.histories
            }, {
              emptystate: _withCtx(() => [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                    _createTextVNode("Aucune entrées correspondants trouvés", -1)
                  ])),
                  _: 1,
                  __: [28]
                })
              ]),
              "table-row": _withCtx((props) => [
                (props.column.field === 'history_type')
                  ? (_openBlock(), _createElementBlock("b", _hoisted_51, _toDisplayString(props.row.text), 1))
                  : (props.column.field === 'action_by_name')
                    ? (_openBlock(), _createElementBlock("b", _hoisted_52, _toDisplayString(props.row.action_by_name), 1))
                    : (props.column.field === 'created_at')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.getDate(props.row.created_at)), 1),
                          _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1))
                        ], 64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(props.formattedRow[props.column.field]), 1))
              ]),
              _: 1
            }, 8, ["columns", "rows"]),
            _createVNode(_component_TablePager, {
              pagination: _ctx.pagerHist,
              "per-page": _ctx.perPageHist,
              "onUpdate:perPage": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.perPageHist) = $event)),
              onPaginate: _ctx.fetchHistories
            }, null, 8, ["pagination", "per-page", "onPaginate"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", null, "Colis avec ce produit")
          ], -1)),
          _createElementVNode("div", _hoisted_56, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.searchColis) = $event)),
              placeholder: "Chercher",
              type: "text",
              class: "form-control d-inline-block mb-2"
            }, null, 512), [
              [_vModelText, _ctx.searchColis]
            ]),
            _createVNode(_component_vue_good_table, {
              columns: _ctx.columnsColis,
              rows: _ctx.colis
            }, {
              emptystate: _withCtx(() => [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createTextVNode("Aucune entrées correspondants trouvés", -1)
                  ])),
                  _: 1,
                  __: [31]
                })
              ]),
              "table-row": _withCtx((props) => [
                (props.column.field === 'parcel_code')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", null, _toDisplayString(props.row.parcel_code), 1),
                      _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1))
                    ], 64))
                  : (props.column.field === 'created_at')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(props.formattedRow[props.column.field]), 1))
              ]),
              _: 1
            }, 8, ["columns", "rows"]),
            _createVNode(_component_TablePager, {
              pagination: _ctx.pagerColis,
              "per-page": _ctx.perPageColis,
              "onUpdate:perPage": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.perPageColis) = $event)),
              onPaginate: _ctx.fetchColis
            }, null, 8, ["pagination", "per-page", "onPaginate"])
          ])
        ])
      ])
    ])
  ], 64))
}